// extracted by mini-css-extract-plugin
var _1 = "RectangleFormStyle_label__613f4";
export { _1 as "label" }
